import React, { useEffect, useState } from 'react'
import { Alert, Modal } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown';
import { FaArrowRightLong } from "react-icons/fa6";
import { createStepModelData, onFetchMedia, onFetchTaskType } from '../../../../Redux/Actions/TaskCreatorAction';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../../../Redux/Actions/AlertActions';
import { useNavigate } from 'react-router-dom';

const CreateTaskStepModal = (props) => {
    const dispatch = useDispatch()
    const [selectedTaskType, setSelectedTaskType] = useState(null);
    const [selectedSocialType, setSelectedSocialType] = useState(null);
    const [selectedName, setSelectedName] = useState('')
    const [price, setPrice] = useState('')
    const [max_submission, setMax_submission] = useState("")
    const [socialMedia, setSocialMedia] = useState([])
    const [loader, setLoader] = useState({
        fetch: false,

    })
    const [taskType, setTaskType] = useState([])
    const [activeIndex, setActiveIndex] = useState(1)
    const navigation = useNavigate()
    const optionTaskType = taskType?.filter((curElem) => curElem.id !== "7").map((curElem, i) => {
        return {
            name: curElem.name,
            value: curElem.id
        };
    })
    const optionSocialType = socialMedia?.map((curElem, i) => {
        return {
            name: curElem.name,
            value: curElem.id
        };
    })
    const fetchTaskType = () => {
        dispatch(onFetchTaskType(setTaskType, loader, setLoader))
    }
    const fetchMedia = () => {

        dispatch(onFetchMedia(setSocialMedia, loader, setLoader))
    }

    const handleNext = () => {
        if (+activeIndex === 1) {
            if (selectedTaskType === null) {
                dispatch(setAlert("select task type", "danger"))
                return;
            }
        }
        if (+activeIndex === 2) {
            if (selectedSocialType === null) {
                dispatch(setAlert("select social type", "danger"))
                return;
            }
        }
        if (+activeIndex === 3) {
            if (max_submission === "" || max_submission < 100) {
                dispatch(setAlert("Enter submission (minimum 100) ", "danger"))
                return;
            }
        }


        if (+activeIndex === 3) {
            let data = {
                category: "5",
                type: selectedTaskType,
                social_media: selectedSocialType,
                max_submission: max_submission,
                price: price
            }
            localStorage.setItem("data", JSON.stringify(data));

            dispatch(createStepModelData(data))
            navigation("/create/task")

        } else {

            setActiveIndex(activeIndex + 1)
        }
    }
    useEffect(() => {

        fetchTaskType()
        fetchMedia()
    }, [])
    useEffect(() => {
        if (selectedTaskType) {
            let data = taskType?.filter((curElem) => curElem.id == selectedTaskType)

            setPrice(data[0].price)
            setSelectedName(data[0].name)
        }

    }, [selectedTaskType])
    const handleActive = (type) => {
        if (type === 2) {
            if (selectedTaskType === null) {
                dispatch(setAlert("select task type", "danger"))
                return;
            }
            setActiveIndex(2)
        }
        if (type === 3) {
            if (selectedTaskType === null) {
                dispatch(setAlert("select task type", "danger"))
                return;
            }
            if (selectedSocialType === null) {
                dispatch(setAlert("select social type", "danger"))
                return;
            }
            setActiveIndex(3)
        }
    }

    return (
        <Modal
            className="theme-modal Payout_request_wrap step-modal"
            show={props.show}
            onHide={props.handleClose}
            backdrop="static"
            centered
        >
            <Modal.Header closeButton style={{ borderBottom: "0" }}>
            </Modal.Header>
            <Modal.Body className='pt-0'>
                <div className="p-3 theme-stepper pt-1">
                    <ul className="d-flex align-items-center justify-content-between mb-4">
                        <li className="user-stepper">
                            <div className="d-flex align-items-center flex-column" onClick={() => setActiveIndex(1)}>
                                <span className={+activeIndex === +1 ? "user-stepper-num active-step" : "user-stepper-num inactive-step"} style={{ cursor: "pointer" }}>1</span><span className="user-stepper-heading">Step 1</span></div>
                            <span className={`user-stepper-line ${+activeIndex >= 2 ? "active-step" : ""}`}></span>
                        </li>
                        <li className="user-stepper">
                            <div className="d-flex align-items-center flex-column" onClick={() => handleActive(2)}>
                                <span className={+activeIndex === +2 ? "user-stepper-num active-step" : "user-stepper-num inactive-step"} style={{ cursor: "pointer" }}>2</span><span className="user-stepper-heading">Step 2</span></div>
                            <span className={`user-stepper-line ${+activeIndex >= 3 ? "active-step" : ""}`}></span>
                        </li>
                        <li className="user-stepper">
                            <div className="d-flex align-items-center flex-column" onClick={() => handleActive(3)}><span className={+activeIndex === +3 ? "user-stepper-num active-step" : "user-stepper-num inactive-step"} style={{ cursor: "pointer" }}>3</span><span className="user-stepper-heading">Step 3</span></div>
                        </li>
                    </ul>
                    <div className='creator_new_task h-100'>
                        {+activeIndex !== 1 ? "" : <div className='account-block mb-4'>
                            <div className='submission_wrap submission_bg gap-3 py-0'>
                                <label for="" className="form-label mb-0">Task Type</label>
                                <Dropdown value={selectedTaskType} onChange={(e) => setSelectedTaskType(e.value)} options={optionTaskType} optionLabel="name"
                                    placeholder=" Select Task Type" className="w-full broder-0 " />
                            </div>
                            {price ? <Alert className='p-3 mt-3 mb-0 border-1' variant="success">
                                <p style={{ color: "#0a3622" }}>{price} credits will be charged per {selectedName}</p>
                            </Alert>
                                : ""}
                        </div>}
                        {+activeIndex !== 2 ? "" : <div className='account-block mb-4'>
                            <div className='submission_wrap submission_bg gap-3 py-0'>
                                <label for="" className="form-label mb-0">Social Media</label>
                                <Dropdown value={selectedSocialType} onChange={(e) => setSelectedSocialType(e.value)} options={optionSocialType} optionLabel="name"
                                    placeholder=" Select Social Media" className="w-full broder-0 " />
                            </div>
                        </div>}
                        {+activeIndex !== 3 ? "" : <div className='account-block mb-3 phone-emails'>
                            <div className='submission_wrap submission_bg gap-1'>
                                <label for="" className="form-label mb-1">No. of Submission</label>
                                <input type="number" className="form-control border-0" id=""
                                    placeholder="Enter Submission"
                                    name="max_submission"
                                    value={max_submission}
                                    onChange={(e) => setMax_submission(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (!/^\d$/.test(e.key) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                            e.preventDefault();
                                        }
                                    }}
                                ></input>
                            </div>
                            {max_submission ?
                                <Alert className='p-3 mt-3 mb-0 border-1' variant="success">
                                    <p style={{ color: "#0a3622" }}>{price * max_submission} credits will be charged for this task </p>
                                </Alert>
                                : ""}
                        </div>}
                        <div className='d-flex justify-content-end align-items-center mt-4 gap-2'>
                            {+activeIndex < 2 ? "" : <button className='theme-btn d-flex align-items-center px-4' onClick={() => setActiveIndex(activeIndex - 1)}><FaArrowRightLong style={{ fontSize: "15px", rotate: "-180deg" }} />Back
                            </button>}
                            <button className='theme-btn d-flex align-items-center px-4' onClick={handleNext}>Next<FaArrowRightLong style={{ fontSize: "15px" }} />
                            </button>
                        </div>
                    </div>
                </div>            </Modal.Body>
        </Modal >
    )
}

export default CreateTaskStepModal
